import { AnyAction } from 'redux';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import { AssessmentSummaryPayload } from 'types/assessment-payload';
import { getAssessmentSummary } from 'api/api';
import {
  fetchAssessmentSummaryErrorAction,
  fetchAssSummaryStartAction,
  fetchAssessmentSummarySuccessAction,
} from 'actions/assessmentSummary';
import { GET_ASSESSMENT_SUMMARY } from 'actions/assessmentSummary/types';
import {
  getImportedReport,
  accuracyReportToAssessmentSummary,
} from 'pqaAccuracy/dataTransfer/reportImportCache';

export function* fetchAssessmentSummary({ token }: AnyAction) {
  try {
    const importedReport = getImportedReport();
    if (!!importedReport) {
      yield put(fetchAssSummaryStartAction());

      const summary = accuracyReportToAssessmentSummary(importedReport);
      // console.log('imported summary', summary);

      yield put(fetchAssessmentSummarySuccessAction(summary));

      return;
    }

    yield put(fetchAssSummaryStartAction());

    const { data: summary }: { data: AssessmentSummaryPayload } = yield call(
      getAssessmentSummary,
      token
    );

    // console.log('summary', summary, JSON.stringify(summary));

    yield put(fetchAssessmentSummarySuccessAction(summary));
  } catch (e) {
    yield put(
      fetchAssessmentSummaryErrorAction(
        e.response.data?.message,
        e.response.status
      )
    );
  }
}

export default function* watchFetchAssessmentSummary() {
  yield takeEvery(GET_ASSESSMENT_SUMMARY, fetchAssessmentSummary);
}
